import { useEffect } from "react";
import { PropTypes } from "prop-types";
const DisableRightClick = ({ children }) => {
  useEffect(() => {
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  return <>{children}</>;
};

export default DisableRightClick;

DisableRightClick.propTypes = {
  children: PropTypes.node.isRequired,
};
